<template>
  <v-app theme="dark">
    <v-main class="v-main">

      <div v-if="viewLoginPanel">
        Login with your Google account to use the Presenter
        <CognitoLogin />
      </div>

      <div v-if="viewInstructions" class="instructionsPanel">
        <h2>Show Presenter</h2>
        <hr>
        <br>
        Choose what is displayed in this window:<br>
        <br>


        <div class="separateColumns">
          <div>
            <v-btn @click="this.viewPresenterPanel = true" color="primary">Show Presenter</v-btn>&nbsp;&nbsp;
          </div>
          <div>Open first. <br>
            This window should be displayed full screen and projected for the audience.</div>
        </div>

        <br>

        <div class="separateColumns">
          <div>
            <v-btn @click="this.viewControlPanel = true" color="primary">Control Panel</v-btn>
          </div>
          <div>Open Second. <br>
            This window is used to control what happens in the Presenter window and should not be shown
            to the audience.
          </div>
        </div>

        <br>
      </div>

      <ControlPanel v-if="viewControlPanel" :auth-token="idToken" />
      <PresenterPanel v-if="viewPresenterPanel" :auth-token="idToken" />

    </v-main>
  </v-app>
</template>

<script>
import { userManager } from '../../photo-prov-shared/lib/classes/cognitoAuth.mjs';
import CognitoLogin from '../../photo-prov-shared/lib/components/CognitoLogin.vue';
import ControlPanel from './components/ControlPanel.vue';
import PresenterPanel from './components/PresenterPanel.vue';

export default {
  name: 'App',
  components: {
    CognitoLogin,
    ControlPanel,
    PresenterPanel
  },
  data() {
    return {
      viewControlPanel: false,
      viewPresenterPanel: false,
      viewLoginPanel: false,
      userIsAdmin: false,
      userEmail: null,
      accessToken: null,
      idToken: null,
      errorMsg: null,
    }
  },
  computed: {
    viewInstructions() {
      return this.userIsAdmin &&
        !this.viewControlPanel &&
        !this.viewPresenterPanel;
    }
  },
  created() {
  },
  mounted() {
    // debug...
    console.log(`VUE_APP_ADMIN_AUTH_CALLBACK_URI: ${process.env.VUE_APP_ADMIN_AUTH_CALLBACK_URI}`);

    // userManager is used to process OIDC callback is not yet initialized (hidden iFrame?, etc.) at this point
    // so we need to use a timeout. i.e., avoid  "Cannot access 'userManager' before initialization" error
    // (kind of a hack - TODO: better way to handle this?)
    setTimeout(() => {
      this.checkAuth(this);
    }, 200);

  },
  methods: {
    checkAuth(myThis) {
      // check to see if we're handling the callback after sign in
      // (look for code= query param)
      const queryString = window.location.search; // e.g., "?code=12345&state=xyz"
      const urlParams = new URLSearchParams(queryString);
      const authCode = urlParams.get('code');
      // const authState = urlParams.get('state');

      if (!authCode) {
        this.viewLoginPanel = true;
        this.userIsAdmin = false;
      }
      else {

        userManager.signinCallback()
          .then(function (user) {
            // debug... console.log('signinCallback - user:\n', user);
            // this method is called from a timeout callback so we need to use this myThis hack
            myThis.viewLoginPanel = false;
            myThis.userIsAdmin = true;
            myThis.errorMsg = null;
            myThis.accessToken = user.access_token;
            myThis.idToken = user.id_token;
            myThis.userEmail = user.profile.email;
            // debug...
            console.log(`authenticated user email: ${myThis.userEmail}`);
            // console.log(`access token: ${myThis.accessToken}`);
            console.log(`id token: ${myThis.idToken}`);
          })
          .catch(function (error) {
            // an error will occur (HTTP 400) if Google user is signed in
            // but is not a member of the photoProvAdmins group
            console.log('signinCallback - error:\n', error);
            myThis.viewLoginPanel = true;
            myThis.userIsAdmin = false;
            myThis.errorMsg = "Google user does not have admin permissions";
          });
      }

    },

  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 10px;
}

.instructionsPanel {
  background-color: lightgray;
  color: black;
  text-align: center;
  padding-bottom: 20px;
}

.separateColumns {
  border: 0px solid purple;
  display: flex;
  text-align: left;
  margin-right: 20px;
}

.error {
  color: red;
}

div {
  margin: 1%;
}

input {
  margin: 1%;
}

label {
  margin: 1%;
}
</style>
